export default __webpack_public_path__ + "static/media/fa-regular-400.0747be4c.eot";